import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/sys/region"

const sysRegion = {
  getTreeSysRegionList(pageSize, limit, keyWord) {
    return axios.get(pre + `/getTreeSysRegionList`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord
        }
    });
  },

  sysRegionInfo(id) {
    return axios.get(pre + `/sysRegionInfo`, {params: {id: id}});
  },
  saveSysRegion(params) {
    return axios.post(pre + `/saveSysRegion`, qs.stringify(params));
  },
  sysRegionDelete(id) {
    return axios.delete(pre + `/sysRegionDelete`, {params: {id: id}});
  },
}
export default sysRegion;



// WEBPACK FOOTER //
// ./src/api/sys/region.js